export default {
  namespaced: true,
  state: {
    isSlideOutVisible: false,
    isSliderPresent: false,
  },

  mutations: {
    CLOSE_SLIDEOUT (state) {
      state.isSlideOutVisible = false
    },

    OPEN_SLIDEOUT (state) {
      state.isSlideOutVisible = true
    }
  },

  getters: {
    isSlideOutVisible (state) {
      return state.isSlideOutVisible
    },

    isSliderPresent (state) {
      return state.isSliderPresent
    }
  }
}
